import { render, staticRenderFns } from "./MessageBoard.vue?vue&type=template&id=636b0e2c&scoped=true&"
import script from "./MessageBoard.vue?vue&type=script&lang=js&"
export * from "./MessageBoard.vue?vue&type=script&lang=js&"
import style0 from "./MessageBoard.vue?vue&type=style&index=0&id=636b0e2c&lang=scss&scoped=true&"
import style1 from "./MessageBoard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636b0e2c",
  null
  
)

export default component.exports